import {
  Dialog,
  DialogContent,
  DialogContentText,
  Divider,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from "@material-ui/core";
import { CheckCircle,DeleteForever } from "@material-ui/icons";
import React, { useEffect, useContext, useState } from "react";

import SnackbarContext from "../../contexts/Snackbar";
import requestAdapter from "../../api/request";

import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";

import { makeStyles, useTheme } from "@material-ui/core/styles";

import PropTypes from "prop-types";
import ButtonRounded from "../../components/ButtonRounded";
import ConfirmationApprove from "../../components/ConfirmationApprove";
import ConfirmationDelete from "../../components/ConfirmationDelete";
const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));

function TablePaginationActions(props) {
  const classes = useStyles1();
  const theme = useTheme();
  const { count, page, rowsPerPage, onChangePage } = props;

  const handleFirstPageButtonClick = (event) => {
    onChangePage(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onChangePage(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onChangePage(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="primeira página"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="página anterior"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="próxima página"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="última página"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

function MyClientsApprove() {
  const { setSnack } = useContext(SnackbarContext);
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [code, setCode] = useState("");
  const [open, setOpen] = React.useState(false);
  const [transactionDetail] = useState({});

  const [modalShow, setModalShow] = useState(false);
  const [modalDeleteShow, setModalDeleteShow] = useState(false);
  const [nameApprove, setNameApprove] = useState();

  const handleClickOpen = async (data) => {
    if(data.statusMatera !== "APPROVED") {
      setSnack({
        message: "Você só pode aprovar clientes que já tenham sido aprovados pela Matera.",
        open: true,
        severity: "error",
      });
      return;
    }

    setNameApprove(data);
    setModalShow(true);
  };

  const handleClose = () => {
    setOpen(false);
  };


  const handleClickDeleteOpen = async (data) => {
    if(data.statusMatera !== "REJECTED") {
      setSnack({
        message: "Você só pode deletar contas que foram rejeitadas pela Matera!",
        open: true,
        severity: "error",
      });
      return;
    }

    setNameApprove(data);
    setModalDeleteShow(true);
  };



  const getData = async () => {
    try {
      const res = await requestAdapter.get(`/admin/clients/toapprove`);
      if (res.status === 200) {
        if (res.data) {
          let rows = res.data.users;
          //console.log(rows);
          //rows = rows.sort((a, b) => (a.entryDate > b.entryDate ? -1 : 1));
          setRows(rows);
          setFilteredRows(rows);
        }
      }
    } catch (ex) {
      setSnack({
        message: "Ocorreu um erro, tente novamente",
        open: true,
        severity: "error",
      });
    }
  };
  useEffect(() => {
   
    getData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  function formatDate(d) {
    if (!d) return "";
    const x = d.split("T");
    const data = x[0].split("-");
    return `${data[2]}/${data[1]}/${data[0]} ${x[1].split(".")[0]}`;
  }

  function search() {
    let aux = rows;
  
    if (code) {
      aux = aux.filter((a) => a.taxId.indexOf(code) !== -1 || a.name.indexOf(code) !== -1 || a.email.indexOf(code) !== -1);
    }
 
    handleChangePage({}, 0);
    setFilteredRows(aux);
  }

  async function confirm() {
    const data = nameApprove;
    setModalShow(false);
    try {
      const res = await requestAdapter.post(`/admin/clients/approve`, {
        id: data.user_id
      });
      
      if (res.status) {
        setSnack({ open: true, message: "Cliente aprovado!" });
        getData();
      }
    } catch (ex) {
      console.log(ex);

      setSnack({ open: true, message: "Ocorreu um erro, tente novamente!", 
      severity: "error", });
    }
  }

  async function confirmDeletion() {
    const data = nameApprove;
    setModalDeleteShow(false);
    try {
      const res = await requestAdapter.post(`/admin/clients/remove`, {
        id: data.user_id
      });
      
      if (res.status) {
        setSnack({ open: true, message: "Cliente removido com sucesso!" });
        getData();
      }
    } catch (ex) {
      console.log(ex);

      setSnack({ open: true, message: "Ocorreu um erro, tente novamente!", 
      severity: "error", });
    }
  }


  return (
    <div>
      {modalShow && <ConfirmationApprove   show={modalShow} name={nameApprove.name} 
      onHide={() => setModalShow(false)} confirm={confirm}/>}
      {modalDeleteShow && <ConfirmationDelete   show={modalDeleteShow} name={nameApprove.name}   onHide={() => setModalDeleteShow(false)} confirm={confirmDeletion}/>}
      
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent style={{ minWidth: "600px" }}>
          <DialogContentText id="alert-dialog-description">
            <Typography style={{ textAlign: "center" }} variant="body1">
              <b style={{ fontWeight: "bold" }}>Transações - Detalhamento</b>
            </Typography>
            <Divider
              style={{
                background: "var(--color-orange-mid)",
                width: "20%",
                marginLeft: "auto",
                marginRight: "auto",
                marginBottom: 20,
                textAlign: "center",
              }}
            />
            {!transactionDetail && (
              <Typography style={{ textAlign: "center" }} variant="body1">
                Não foi possível encontrar a transação selecionada
              </Typography>
            )}
            {transactionDetail && (
              <Typography variant="body2">
                Data da transação:{" "}
                <b style={{ fontWeight: "bold" }}>{formatDate(transactionDetail.createdAt)}</b>
                <br />
                Tipo da transação:{" "}
                <b style={{ fontWeight: "bold" }}>{transactionDetail.type === "C" ? "Entrada" : "Saída"}</b>
                <br />
                Valor da transação:{" "}
                <b style={{ fontWeight: "bold" }}>
                  {transactionDetail.type === "C" ? "+" : "-"}R${" "}
                  {Number(transactionDetail.totalAmount).toFixed(2)}
                </b>
                <br />
                {transactionDetail.fee && (
                  <span>
                    Taxas: <b style={{ fontWeight: "bold" }}>-R$ {transactionDetail.fee}</b>
                    <br />
                  </span>
                )}
                {transactionDetail.type === "C" && (
                  <span>
                    Recebido de:{" "}
                    <b style={{ fontWeight: "bold" }}>
                      {transactionDetail.sender_name} -{" "}
                      {transactionDetail.sender_taxidmasked} /{" "}
                      {transactionDetail.sender_pspname}
                    </b>
                    <br />
                  </span>
                )}
                {transactionDetail.type === "D" && (
                  <span>
                    Enviado para:{" "}
                    <b style={{ fontWeight: "bold" }}>
                      {transactionDetail.receiver_name} -{" "}
                      {transactionDetail.receiver_taxidmasked} /{" "}
                      {transactionDetail.receiver_pspname}
                    </b>
                    <br />
                  </span>
                )}
              </Typography>
            )}
            <Grid
              container
              style={{ paddingTop: 10, justifyContent: "center" }}
            >
              <Grid item>
                <ButtonRounded
                  onClick={handleClose}
                  text={"Fechar"}
                ></ButtonRounded>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>
      <Grid
        container
        justify="center"
        style={{ paddingTop: "25px", textAlign: "center" }}
      >
        <Grid item xs={12}>
          <Typography variant="h5">Clientes a serem aprovados</Typography>
        </Grid>

        <Divider
          style={{
            background: "var(--color-orange-mid)",
            width: "20%",
            marginLeft: "auto",
            marginRight: "auto",
            marginBottom: 20,
            textAlign: "center",
          }}
        />
      </Grid>

      <Grid
        container
        spacing={1}
        style={{ marginBottom: 10, alignItems: "center" }}
      >
        <Grid item xs={6}>
          <TextField
            fullWidth
            size="small"
            type="text"
            onChange={(ev) => setCode(ev.target.value)}
            variant="outlined"
            label="Pesquisar por CNPJ ou Nome"
            name="code"
          />
        </Grid>
     
       

        <Grid item xs={1}>
          <ButtonRounded onClick={search} text={"Buscar"}></ButtonRounded>
        </Grid>
      </Grid>

      <Divider
        style={{
          background: "var(--color-orange-mid)",
          width: "20%",
          marginLeft: "auto",
          marginRight: "auto",
          marginBottom: 20,
          textAlign: "center",
        }}
      />
      
      

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell>CNPJ</TableCell>
              <TableCell align="left">Nome da empresa</TableCell>
              <TableCell align="left">E-mail da empresa</TableCell>
              <TableCell align="left">Status Matera</TableCell>
              <TableCell align="center">Ação</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(rowsPerPage > 0
              ? filteredRows.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                )
              : filteredRows
            ).map((row, index) => (
              <TableRow
                key={index}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {row.taxId}
                </TableCell>

                <TableCell align="left">{row.name}</TableCell>
                <TableCell align="left">
                  {row.email}
                </TableCell>
                
                <TableCell align="left">
                  {row.statusMatera}
                </TableCell>
                <TableCell align="center">
                  <IconButton
                      aria-label="Sair do sistema"
                      color="inherit"
                      onClick={() => handleClickOpen(row)}
                    >
                      <CheckCircle />
                    </IconButton>
                    <IconButton
                      aria-label="Deletar conta"
                      color="inherit"
                      onClick={() => handleClickDeleteOpen(row)}
                    >
                      <DeleteForever />
                    </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, { label: "Todos", value: -1 }]}
                colSpan={3}
                count={filteredRows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: { "aria-label": "Linhas por página" },
                  native: true,
                }}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
                labelRowsPerPage={"Linhas por página"}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    </div>
  );
}

export default MyClientsApprove;
